<template>
    <base-modal
        :reference="'show_' + bookingId"
        :title="'Todos los datos de la reserva'"
        :acceptAction="acceptAction"
        :cancelActionText="'Cerrar'"
        :size="'lg'"
    >
        <template v-slot:body v-if="show">
            
            <b-container class="text-left" >
                <b-row>
                    <b-col cols="5" class="text-center font-weight-bold mt-3">Datos del cliente</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Nombre</b-col>
                    <b-col cols="6">{{booking.customer_name}}</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Teléfono</b-col>
                    <b-col cols="6">{{booking.customer_phone}}</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Correo electrónico</b-col>
                    <b-col cols="6">{{booking.customer_email}}</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Hotel</b-col>
                    <b-col cols="6">{{booking.trekksoft_hotel_name}}</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Habitación</b-col>
                    <b-col cols="6">{{booking.trekksoft_hotel_room}}</b-col>
                </b-row>

                <b-row>
                    <b-col cols="5" class="text-center font-weight-bold mt-3">Datos de la reserva</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Id interno</b-col>
                    <b-col cols="6">{{booking.id}}</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Identificador reserva</b-col>
                    <b-col cols="6">{{booking.trekksoft_booking_id}}</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Fecha de compra</b-col>
                    <b-col cols="6">{{booking.purchase_date}}</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Actividad/tour</b-col>
                    <b-col cols="6">{{booking.trekksoft_activity_name}}</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Grupo</b-col>
                    <b-col cols="6">{{booking.stop != null ? booking.stop.activity_group.name : booking.activity_group != null ? booking.activity_group.name : 'Sin asignarr'}}</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Día actividad</b-col>
                    <b-col cols="6">{{booking.day}}</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">PAX</b-col>
                    <b-col cols="6">{{booking.customer_adults}} adultos / {{booking.customer_children}} niños</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Idioma</b-col>
                    <b-col cols="6">
                        <country-flag
                            v-if="booking.customer_language != 'otro'"
                            :country="booking.customer_language"
                            size="small"
                        />
                        <span class="ml-2 text-uppercase">{{booking.customer_language}}</span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="5" class="text-center font-weight-bold mt-3">Datos operativos</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Parada asignada</b-col>
                    <b-col cols="6">{{booking.stop != null ? booking.stop.geo_point.name : 'Sin asignar'}} (id: {{booking.stop != null ? booking.stop.geo_point.id : '?'}})</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Hora parada</b-col>
                    <b-col cols="6">{{booking.stop != null ? booking.stop.hora : 'Sin asignar'}}</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Bus de excursión</b-col>
                    <b-col cols="6" v-if="excursionBus != null">
                        <p>Nombre: 
                            <span
                                    class="badge"
                                    :style="{ backgroundColor: excursionBus.color_code, color:invertHex(excursionBus.color_code) }">
                                {{excursionBus.name}}
                            </span>
                        </p>
                        <p>Número: {{excursionBus.number}}</p>
                        <p>Capacidad máxima: {{excursionBus.max_size}} pax</p>
                        
                        <p>Bus cerrado: <i class="fa mx-2" :class="excursionBus.bus_closed ? 'fa-lock' : 'fa-unlock'" /> {{excursionBus.bus_closed ? 'Sí' : 'No'}}</p>
                        
                        <p>Nombre del guía: {{excursionBus.person_name == '' ? '--' : excursionBus.person_name}}</p>
                        <p>Recogida del guía en {{excursionBus.person_pickup_point == '' ? '--' : excursionBus.person_pickup_point}} a las {{excursionBus.person_pickup_time == '' ? '--' : excursionBus.person_pickup_time}}</p>
                    </b-col>
                    <b-col cols="6" v-else>Sin asignar</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Bus de recogida</b-col>
                    <b-col cols="6" v-if="pickupBus != null">
                        <p>Nombre: 
                            <span
                                    class="badge"
                                    :style="{ backgroundColor: pickupBus.color_code, color:invertHex(pickupBus.color_code) }">
                                {{pickupBus.name}}
                            </span>
                        </p>
                        <p>Número: {{pickupBus.number}}</p>
                        <p>Capacidad máxima: {{pickupBus.max_size}} pax</p>
                        
                        <p>Bus cerrado: <i class="fa mx-2" :class="pickupBus.bus_closed ? 'fa-lock' : 'fa-unlock'" /> {{pickupBus.bus_closed ? 'Sí' : 'No'}}</p>
                        
                        <p>Nombre del guía: {{pickupBus.person_name}}</p>
                        <p>Recogida del guía: {{pickupBus.person_pickup_point}} a las {{pickupBus.person_pickup_time}}</p>
                    </b-col>
                    <b-col cols="6" v-else>Sin asignar</b-col>
                </b-row>

                <b-row align-h="center">
                    <b-col cols="3">Bus de devolución</b-col>
                    <b-col cols="6" v-if="returnBus != null">
                        <p>Nombre: 
                            <span
                                    class="badge"
                                    :style="{ backgroundColor: returnBus.color_code, color:invertHex(returnBus.color_code) }">
                                {{returnBus.name}}
                            </span>
                        </p>
                        <p>Número: {{returnBus.number}}</p>
                        <p>Capacidad máxima: {{returnBus.max_size}} pax</p>
                        
                        <p>Bus cerrado: <i class="fa mx-2" :class="returnBus.bus_closed ? 'fa-lock' : 'fa-unlock'" /> {{returnBus.bus_closed ? 'Sí' : 'No'}}</p>
                        
                        <p>Nombre del guía: {{returnBus.person_name}}</p>
                        <p>Recogida del guía: {{returnBus.person_pickup_point}} a las {{returnBus.person_pickup_time}}</p>
                    </b-col>
                    <b-col cols="6" v-else>Sin asignar</b-col>
                </b-row>

                <b-row>
                    <b-col cols="5" class="text-center font-weight-bold mt-3">Servicios de bus</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Servicio de recogida</b-col>
                    <b-col cols="6">
                        <i :class="booking.pickup_service ? 'fa fa-check-circle text-info' : 'fa fa-times-circle text-danger'"></i>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Servicio de excursión</b-col>
                    <b-col cols="6">
                        <i :class="booking.excursion_service ? 'fa fa-check-circle text-success' : 'fa fa-times-circle text-danger'"></i>
                    </b-col>
                </b-row>
                <b-row align-h="center" v-if="booking.integration == 'zerotours'">
                    <b-col cols="3">Transporte incluido (según Zerotours)</b-col>
                    <b-col cols="6">
                        <i :class="booking.includes_transport ? 'fa fa-check-circle text-success' : 'fa fa-times-circle text-danger'"></i>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="5" class="text-center font-weight-bold mt-3">Datos adicionales</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Punto venta</b-col>
                    <b-col cols="6">{{booking.agency}}</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Canal venta</b-col>
                    <b-col cols="6">{{booking.channel}}</b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">Comentarios/notas</b-col>
                    <b-col cols="6" v-html="booking.trekksoft_remarks"></b-col>
                </b-row>

                
            </b-container>
        </template>
        <template v-slot:accept-action>
            <span></span>
        </template>
    </base-modal>
</template>

<script>
/* eslint-disable */

import BaseModal from './BaseModal';
import utilsColors from "../../../../utils/colors";
import { mapGetters } from 'vuex';


export default {
    components: {
        BaseModal,
    },
    props: {
        bookingId: {
            type: Number,
            required: true,
        }
    },
    data: () => {
        return {
            booking: null,
            show: false
        }
    },
    mixins: [utilsColors],
    async mounted() {
        this.$root.$on('bv::modal::show', async (bvEvent, modalId) => {
            if ( modalId === 'show_'+this.bookingId) {
                console.log("modal booking id " + this.bookingId + " " + this.activeTab)
                const booking = await this.$store.getters.booking(this.bookingId, this.activeTab)
                console.log('showcompletebooking', booking)
                this.booking = booking
                this.show = true
            }
        })
    },
    methods: {
        acceptAction() {
            this.$bvModal.hide('edit_'+this.bookingId);
        },
        _getBus(type) {
            let list = this.booking.bookingrelbus_set.filter(bus => bus.bus_type_rel.type == type)
            if (list.length == 1 )
                return list[0].bus_type_rel
            return null
        },
    },
    computed: {
        ...mapGetters(["activeTab"]),
        pickupBus() {  
            return this._getBus('Pickup')
        },
        excursionBus() {
            return this._getBus('Excursion')
        },
        returnBus() {
            return this._getBus('Return')
        },
    }
}
</script>

<style scoped>
p {
    margin-bottom: 1px;
}
</style>